import styled, { css } from "styled-components/native";
import marginBottom, { MarginBottomProps } from "../helpers/marginBottom";
import { borderRadius, spacing, wpdColor } from "../theme";

interface BoxProps extends MarginBottomProps {
  last?: boolean;
  backgroundColor?: string;
}

export default styled.View<BoxProps>`
  padding: ${spacing.medium} ${spacing.large};
  background-color: ${({ backgroundColor }: BoxProps) =>
    backgroundColor || wpdColor.primaryContrastLighter};
  border-radius: ${borderRadius.small};

  ${(props: BoxProps) => marginBottom(props)};

  ${({ last }: BoxProps) =>
    last &&
    css`
      margin-bottom: 0;
    `};
`;
